import i18n from '../i18n';
import { getCategoryNameRu } from './categoryHelpers';

export const getActivityText = (activity) => {
  switch (activity.type) {
    case 'added_to_shelf':
      return i18n.t('feed.addedToShelf');
    case 'added_to_wishlist':
      return i18n.t('feed.addedToWishlist');
    case 'rated':
      return `${i18n.t('feed.rated')} ${activity.rating_value}`;
    case 'commented':
      return i18n.t('feed.commented');
    case 'joined_fandom':
      return 'Вступил в фандом';
    case 'achievement':
      return 'Получил достижение';
    case 'created_collection':
      return 'Создал подборку';
    case 'status_update':
      return 'Изменил статус';
    case 'review':
      return 'Написал рецензию';
    default:
      return i18n.t('feed.shared');
  }
};

export const formatTime = (dateString) => {
  if (!dateString) return '';
  const utcDateString = dateString.includes('Z') ? dateString : dateString.replace(' ', 'T') + 'Z';
  const date = new Date(utcDateString);
  const now = new Date();

  if (isNaN(date.getTime())) return '';

  const diff = now - date;
  if (diff < 0) return '';

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  const lang = i18n.language;

  if (seconds < 60) return lang === 'en' ? 'Just now' : 'Только что';
  if (minutes < 60) return lang === 'en' ? `${minutes} min. ago` : `${minutes} мин. назад`;
  if (hours < 24) return lang === 'en' ? `${hours} h. ago` : `${hours} ч. назад`;
  if (days < 7) return lang === 'en' ? `${days} d. ago` : `${days} дн. назад`;

  return date.toLocaleDateString(lang === 'en' ? 'en-US' : 'ru-RU', {
    day: 'numeric',
    month: 'short',
  });
};

/**
 * Определяет статус друга на основе last_seen.
 * Возвращает:
 *   - 'online' — если пользователь был в сети менее 2 минут назад
 *   - строку с относительным временем — если больше 2 минут
 *   - null — если дата отсутствует
 */
export const formatLastSeen = (lastSeenDate) => {
  if (!lastSeenDate) return null;

  const utcDateString = lastSeenDate.includes('Z') ? lastSeenDate : lastSeenDate.replace(' ', 'T') + 'Z';
  const date = new Date(utcDateString);
  const now = new Date();

  if (isNaN(date.getTime())) return null;

  const diff = now - date;
  if (diff < 0) return null;

  const minutes = Math.floor(diff / 60000);

  // Если был в сети менее 2 минут назад — считаем онлайн
  if (minutes < 2) return 'online';

  // Иначе форматируем относительное время (переиспользуем formatTime)
  return formatTime(lastSeenDate);
};

export const truncateDescription = (text, maxLength = 150) => {
  if (!text) return i18n.t('common.noDescription', 'Описание отсутствует');
  const cleanText = String(text)
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (cleanText.length <= maxLength) return cleanText;
  return `${cleanText.slice(0, maxLength).trimEnd()}...`;
};

export const normalizeGenres = (genres, fallbackCategory) => {
  const normalized = (genres || [])
    .map((genre) => {
      if (!genre) return '';
      if (typeof genre === 'string') return genre.trim();
      if (typeof genre === 'object') return (genre.name || '').trim();
      return '';
    })
    .filter(Boolean)
    .slice(0, 2);

  if (normalized.length < 2) {
    normalized.push(getCategoryNameRu(fallbackCategory));
  }
  if (normalized.length < 2) {
    normalized.push(i18n.t('itemDetail.category.default', 'Медиапроект'));
  }
  return normalized.slice(0, 2);
};

export const prepareItemData = (activity, activityMeta, activityImage) => {
  const genreNames = (activityMeta.genres || activity.genres || [])
    .map((g) => (typeof g === 'object' && g !== null ? g.name || '' : g))
    .filter(Boolean);

  const poster =
    activity.category === 'music'
      ? activityImage || activity.item_image || activityMeta.artwork || null
      : activityMeta.poster || activity.poster || activity.item_image || null;

  const backdrop = activityMeta.backdrop || activity.backdrop || activity.item_image || null;

  return {
    id: activity.external_id,
    external_id: activity.external_id,
    title: activity.item_title,
    category: activity.category,
    artwork: activity.category === 'music' ? activityImage || activity.item_image || activityMeta.artwork || null : undefined,
    poster,
    backdrop,
    releaseDate: activity.release_date || (activityMeta.year ? `${activityMeta.year}-01-01` : null),
    originalTitle: activity.original_title || activity.originalTitle,
    overview: activityMeta.description || activity.description || activity.overview || '',
    genres: genreNames,
  };
};